
export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services', 
      rates: 'Tarifs', 
      reviews: 'Avis',
      booking: 'Réservation',
      about: 'À propos',
      gallery: 'Galerie',
      contact: 'Contact',
      admin: 'Administration',
      logout: 'Déconnexion',
      login: 'Connexion',
      profile: 'Mon Profil',
      myAccount: 'Mon Compte',
      roleAdmin: 'Administrateur',
      roleUser: 'Client',
      myBookings: 'Mes RDV'
    },
    userBookings: {
      title: 'Mes Rendez-vous',
      subtitle: "Retrouvez l'historique et le suivi de vos prestations.",
      countLabel: 'Prestations',
      searchPlaceholder: 'Rechercher une prestation ou une adresse...',
      filterAll: 'Tous',
      filterConfirmed: 'Confirmés',
      filterPending: 'En attente',
      guaranteeLabel: 'Garantie',
      emptyTitle: 'Aucun rendez-vous trouvé',
      emptySearch: 'Essayez de modifier vos filtres de recherche',
      emptyNoBookings: "Vous n'avez pas encore effectué de réservation.",
      loading: 'Chargement de vos rendez-vous...',
      error: 'Erreur lors de la récupération',
      retry: 'Réessayer',
      status: {
        confirmed: 'Confirmé',
        pending: 'En attente',
        cancelled: 'Annulé',
        'no-show': 'Non honoré'
      }
    },
    hero: {
      badge: "L'EXCELLENCE À VOTRE PORTE",
      title: "Haircare & Relaxation",
      subtitle: 'Héritage & Passion',
      cta: 'En savoir plus'
    },
    rates: {
      badge: 'Services de Prestige',
      title: 'Nos Prestations & Tarifs',
      subtitle: 'Sélectionnez une catégorie pour découvrir nos services',
      bookBtn: 'Réserver',
      viewDetails: 'VOIR LES PRESTATIONS',
      prestigeLabel: 'Prestations de prestige',
      priceLabel: 'Tarif',
      noService: 'Aucun service disponible.',
      categories: {
        haircut: 'Coupe',
        coloring: 'Coloration',
        balayage: 'Balayage',
        lissage: 'Lissage Brésilien',
        styling: 'Coiffage',
        treatment: 'Soins',
        pack: 'Packs / Forfaits',
        massageDetente: 'Massage & Détente',
        massageSoins: 'Massage et Soins',
        extras: 'Extras / Services +'
      }
    },
    reviews: {
        badge: 'Témoignages Authentiques',
        title: 'Avis Clients',
        subtitle: 'Découvrez ce que nos clients pensent de nous',
        addTitle: 'Laisser un avis',
        ratingLabel: 'Votre note',
        commentLabel: 'Votre commentaire',
        placeholder: 'Racontez-nous votre expérience...',
        submit: 'Publier mon avis',
        loginRequired: 'Veuillez vous connecter pour laisser un avis.',
        empty: 'Soyez le premier à laisser un avis !'
    },
    booking: {
      title: 'Réserver votre prestation',
      steps: {
        services: '01. Prestations',
        date: '02. Date',
        time: '03. Heure',
        personal: '04. Coordonnées',
        summary: '05. Récapitulatif'
      },
      selectService: 'Sélectionner un service...',
      addService: 'Ajouter un service',
      selectDateFirst: 'Sélectionnez une date',
      name: 'Nom complet *',
      email: 'Email *',
      phone: 'Téléphone',
      address: 'Adresse complète *',
      validation: {
        service: 'Prestation',
        date: 'Date',
        time: 'Heure',
        name: 'Nom',
        email: 'Email',
        address: 'Adresse'
      },
      summary: {
        estimated: 'Montant Estimé',
        onPlace: 'À régler sur place'
      },
      deposit: {
        title: 'Conditions de Garantie',
        bankGuarantee: 'Garantie Bancaire',
        policy1: 'Empreinte de 20€ par 3D Secure (non débitée).',
        policy2: 'Le rendez-vous doit être confirmé par le coiffeur.',
        accept: "J'accepte les conditions générales",
        disclaimer: "Votre carte sera vérifiée par 3D Secure mais aucun débit n'aura lieu aujourd'hui.",
        completeFormError: 'Veuillez remplir tous les champs et accepter les conditions pour continuer.'
      },
      placeholders: {
        zip: 'Code postal',
        notes: 'Infos complémentaires (digicode, étage...)'
      },
      success: {
        title: 'Demande Envoyée !',
        body: 'Votre garantie a été validée. Votre rendez-vous est maintenant <strong>en attente de confirmation</strong>. Vous recevrez un e-mail de confirmation très prochainement.',
        returnHome: "Retour à l'accueil"
      },
      submit: 'Réserver & Garantir'
    },
    about: {
      badge: 'NOTRE HISTOIRE',
      title: 'À propos de moi',
      subtitle: 'Passion, Excellence & Tradition',
      storyTitle: 'QUI SOMMES-NOUS ?',
      text: "Bonjour, je m'appelle Marie.\n\nJe suis coiffeuse française, avec 14 ans d'expérience et je travaille à domicile à Lisbonne depuis janvier 2024.",
      ctaAbout: 'En savoir plus',
      features: {
        excellence: {
          title: 'Excellence',
          desc: "Un savoir-faire d'exception transmis avec passion pour des résultats impeccables."
        },
        passion: {
          title: 'Passion',
          desc: "Chaque coupe est réalisée avec amour et dévouement pour sublimer votre beauté."
        },
        proximity: {
          title: 'Proximité',
          desc: "Un service personnalisé à domicile pour votre confort et votre bien-être."
        }
      }
    },
    gallery: {
      title: 'Notre Galerie',
      subtitle: 'Découvrez nos réalisations en images et vidéos',
      empty: 'Aucun contenu dans la galerie pour le moment.'
    },
    contact: {
      badge: 'Restons en Contact',
      title: 'Contactez-nous',
      subtitle: 'Nous sommes à votre écoute pour répondre à toutes vos questions',
      phone: 'Téléphone',
      email: 'Email',
      emailSend: 'Cliquez pour envoyer un message',
      hours: 'Horaires',
      hoursText: 'Lun-Dim: 10h-20h',
      socialTitle: 'Suivez-nous',
      socialText: 'Rejoignez notre communauté sur les réseaux sociaux'
    },
    auth: {
      loginTitle: 'Connexion',
      signupTitle: 'Créer un compte',
      welcome: 'Bienvenue chez Haircare & Relaxation',
      name: 'Nom',
      firstname: 'Prénom',
      email: 'Adresse email',
      password: 'Mot de passe',
      phone: 'Téléphone',
      address: 'Adresse complète',
      language: 'Langue préférée',
      submitLogin: 'Se connecter',
      submitSignup: "S'inscrire",
      switchLogin: 'Déjà un compte ? Se connecter',
      switchSignup: "Pas de compte ? S'inscrire",
      backToHome: 'Retour à l\'accueil',
      passwordRequirements: 'Le mot de passe doit contenir au moins 12 caractères, une lettre, un chiffre et un caractère spécial.',
      forgotPassword: 'Mot de passe oublié ?',
      sendResetLink: 'Envoyer le lien',
      resetTitle: 'Réinitialiser le mot de passe',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      resetSuccess: 'Mot de passe réinitialisé ! Vous pouvez vous connecter.',
      emailSent: 'Si ce compte existe, un lien a été envoyé.',
      backToLogin: 'Retour à la connexion'
    },
    profile: {
      title: 'Mon Profil',
      badge: 'Mon Espace Personnel',
      subtitle: 'Gérez vos informations personnelles',
      personalInfo: 'Informations Personnelles',
      success: 'Profil mis à jour avec succès',
      error: 'Erreur lors de la mise à jour du profil',
      security: 'Sécurité',
      oldPassword: 'Ancien mot de passe',
      passSuccess: 'Mot de passe mis à jour !',
      emailNotice: "L'email ne peut pas être modifié.",
      updatePassBtn: 'Mettre à jour le mot de passe'
    },
    admin: {
      title: 'Panneau d\'Administration',
      tabs: {
        bookings: 'Réservations',
        services: 'Services',
        gallery: 'Galerie',
        about: 'À propos',
        account: 'Mon Compte',
        translations: 'Traductions',
        stats: 'Statistiques'
      },
      common: {
        today: "Aujourd'hui",
        day: 'Jour',
        week: 'Semaine',
        month: 'Mois',
        list: 'Liste',
        newBooking: 'Nouveau RDV',
        loading: 'Chargement...',
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        abandon: 'Abandonner',
        edit: 'Modifier',
        actions: 'Actions'
      },
      bookings: {
        modalTitleAdd: 'Planifier une prestation',
        modalTitleEdit: 'Modifier le rendez-vous',
        customer: 'Client',
        service: 'Service',
        date: 'Date',
        time: 'Heure',
        status: 'Statut',
        address: 'Adresse',
        notes: 'Notes',
        confirmed: 'Confirmé',
        pending: 'En attente',
        confirm: 'Confirmer',
        noBookings: 'Aucune réservation trouvée.',
        confirmSuccess: 'Rendez-vous confirmé !'
      },
      services: {
        add: 'Ajouter un service',
        edit: 'Modifier',
        name: 'Nom du service',
        description: 'Description',
        price: 'Prix',
        duration: 'Durée (min)',
        icon: 'Icône',
        save: 'Enregistrer',
        cancel: 'Annuler',
        categoryImages: 'Images des Catégories',
        saveImages: 'Sauvegarder les images',
        placeholders: {
          name: 'Ex: Coupe Femme',
          description: 'Description détaillée du service...',
          price: '0.00'
        },
        icons: {
          scissors: 'Coupe de cheveux',
          droplet: 'Coloration',
          palette: 'Balayage',
          zap: 'Lissage',
          wind: 'Coiffage',
          sparkles: 'Soin',
          pack: 'Pack',
          heart: 'Massage & Détente',
          flower: 'Massage et Soins',
          plus: 'Extras'
        }
      },
      gallery: {
        add: 'Ajouter Média',
        dropzone: 'Glissez des photos ou vidéos ici',
        formats: 'JPG, PNG, MP4, WEBM (Max 50MB)',
        deleteConfirm: 'Supprimer ce média ?',
        success: 'Média ajouté avec succès'
      },
      account: {
        newPassword: 'Nouveau mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        errorMatch: 'Les mots de passe ne correspondent pas',
        success: 'Compte mis à jour avec succès',
        save: 'Enregistrer'
      },
      stats: {
        title: 'Statistiques',
        subtitle: 'Analyse des performances',
        totalRevenue: "Chiffre d'Affaires",
        totalBookings: 'Réservations',
        activeServices: 'Services Actifs',
        detailsTitle: "Détails de l'activité"
      }
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      rates: 'Rates',
      reviews: 'Reviews',
      booking: 'Booking',
      about: 'About',
      gallery: 'Gallery',
      contact: 'Contact',
      admin: 'Admin',
      logout: 'Logout',
      login: 'Login',
      profile: 'My Profile',
      myAccount: 'My Account',
      roleAdmin: 'Administrator',
      roleUser: 'Customer',
      myBookings: 'My Bookings'
    },
    userBookings: {
      title: 'My Appointments',
      subtitle: 'View your service history and follow-up.',
      countLabel: 'Services',
      searchPlaceholder: 'Search for a service or address...',
      filterAll: 'All',
      filterConfirmed: 'Confirmed',
      filterPending: 'Pending',
      guaranteeLabel: 'Guarantee',
      emptyTitle: 'No appointments found',
      emptySearch: 'Try changing your search filters',
      emptyNoBookings: 'You have not made any bookings yet.',
      loading: 'Loading your appointments...',
      error: 'Error during retrieval',
      retry: 'Retry',
      status: {
        confirmed: 'Confirmed',
        pending: 'Pending',
        cancelled: 'Cancelled',
        'no-show': 'No-Show'
      }
    },
    hero: {
      badge: 'EXCELLENCE AT YOUR DOORSTEP',
      title: 'Haircare & Relaxation',
      subtitle: 'Heritage & Passion',
      cta: 'Learn more'
    },
    rates: {
      badge: 'Premium Services',
      title: 'Our Rates & Services',
      subtitle: 'Select a category to see details',
      bookBtn: 'Book Now',
      viewDetails: 'VIEW SERVICES',
      prestigeLabel: 'Prestige services',
      priceLabel: 'Price',
      noService: 'No service available.',
      categories: {
        haircut: 'Haircut',
        coloring: 'Coloring',
        balayage: 'Balayage',
        lissage: 'Brazilian Straightening',
        styling: 'Styling',
        treatment: 'Treatment',
        pack: 'Packages',
        massageDetente: 'Massage & Relaxation',
        massageSoins: 'Massage & Care',
        extras: 'Extras / Add-ons'
      }
    },
    reviews: {
        badge: 'Authentic Testimonials',
        title: 'Customer Reviews',
        subtitle: 'See what our customers say about us',
        addTitle: 'Leave a review',
        ratingLabel: 'Your rating',
        commentLabel: 'Your comment',
        placeholder: 'Tell us about your experience...',
        submit: 'Post review',
        loginRequired: 'Please login to leave a review.',
        empty: 'Be the first to leave a review!'
    },
    booking: {
      title: 'Book your service',
      steps: {
        services: '01. Services',
        date: '02. Date',
        time: '03. Time',
        personal: '04. Details',
        summary: '05. Summary'
      },
      selectService: 'Select a service...',
      addService: 'Add a service',
      selectDateFirst: 'Select a date first',
      name: 'Full name *',
      email: 'Email *',
      phone: 'Phone',
      address: 'Full address *',
      validation: {
        service: 'Service',
        date: 'Date',
        time: 'Time',
        name: 'Name',
        email: 'Email',
        address: 'Address'
      },
      summary: {
        estimated: 'Estimated Total',
        onPlace: 'To pay on site'
      },
      deposit: {
        title: 'Guarantee Conditions',
        bankGuarantee: 'Bank Guarantee',
        policy1: '€20 guarantee via 3D Secure (not charged).',
        policy2: 'The appointment must be confirmed by the hairdresser.',
        accept: 'I accept the terms and conditions',
        disclaimer: 'Your card will be verified by 3D Secure but no charge will occur today.',
        completeFormError: 'Please fill all fields and accept terms to continue.'
      },
      placeholders: {
        zip: 'Zip code',
        notes: 'Additional info (door code, floor...)'
      },
      success: {
        title: 'Request Sent!',
        body: 'Your guarantee has been validated. Your appointment is now <strong>awaiting confirmation</strong>. You will receive a confirmation email shortly.',
        returnHome: 'Back to Home'
      },
      submit: 'Book & Guarantee'
    },
    about: {
      badge: 'OUR STORY',
      title: 'About me',
      subtitle: 'Passion, Excellence & Tradition',
      storyTitle: 'WHO ARE WE?',
      text: "Hello, my name is Marie.\n\nI am a French hairdresser with 14 years of experience, working at home in Lisbon since January 2024.",
      ctaAbout: 'Learn more',
      features: {
        excellence: {
          title: 'Excellence',
          desc: 'Exceptional know-how shared with passion for impeccable results.'
        },
        passion: {
          title: 'Passion',
          desc: 'Each cut is made with love and dedication to enhance your beauty.'
        },
        proximity: {
          title: 'Proximity',
          desc: 'A personalized home service for your comfort and well-being.'
        }
      }
    },
    gallery: {
      title: 'Our Gallery',
      subtitle: 'Discover our work in photos and videos',
      empty: 'No content in the gallery yet.'
    },
    contact: {
      badge: 'Stay in Touch',
      title: 'Contact us',
      subtitle: 'We are here to answer all your questions',
      phone: 'Phone',
      email: 'Email',
      emailSend: 'Click to send a message',
      hours: 'Hours',
      hoursText: 'Mon-Sun: 10am-8pm',
      socialTitle: 'Follow us',
      socialText: 'Join our community on social media'
    },
    auth: {
      loginTitle: 'Login',
      signupTitle: 'Create Account',
      welcome: 'Welcome to Haircare & Relaxation',
      name: 'Last Name',
      firstname: 'First Name',
      email: 'Email Address',
      password: 'Password',
      phone: 'Phone Number',
      address: 'Full Address',
      language: 'Preferred Language',
      submitLogin: 'Log In',
      submitSignup: 'Sign Up',
      switchLogin: 'Already have an account? Log In',
      switchSignup: "No account? Sign Up",
      backToHome: 'Back to Home',
      passwordRequirements: 'Password must be at least 12 characters, including a letter, a number and a special character.',
      forgotPassword: 'Forgot password?',
      sendResetLink: 'Send Link',
      resetTitle: 'Reset Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      resetSuccess: 'Password reset! You can now log in.',
      emailSent: 'If this account exists, a link has been sent.',
      backToLogin: 'Back to Login'
    },
    profile: {
      title: 'My Profile',
	  badge: 'My Personal Space',
      subtitle: 'Manage your personal information',
      personalInfo: 'Personal Information',
      success: 'Profil mis à jour avec succès',
      success: 'Profile updated successfully',
      error: 'Error updating profile',
      security: 'Security',
      oldPassword: 'Old Password',
      passSuccess: 'Password updated!',
      emailNotice: 'Email cannot be changed.',
      updatePassBtn: 'Update password'
    },
    admin: {
      title: 'Admin Panel',
      tabs: {
        bookings: 'Bookings',
        services: 'Services',
        gallery: 'Gallery',
        about: 'About',
        account: 'My Account',
        translations: 'Translations',
        stats: 'Statistics'
      },
      common: {
        today: "Today",
        day: 'Day',
        week: 'Week',
        month: 'Month',
        list: 'List',
        newBooking: 'New Appointment',
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        abandon: 'Discard',
        edit: 'Edit',
        actions: 'Actions'
      },
      bookings: {
        modalTitleAdd: 'Schedule a service',
        modalTitleEdit: 'Edit appointment',
        customer: 'Customer',
        service: 'Service',
        date: 'Date',
        time: 'Time',
        status: 'Status',
        address: 'Address',
        notes: 'Notes',
        confirmed: 'Confirmed',
        pending: 'Pending',
        confirm: 'Confirm',
        noBookings: 'No bookings found.',
        confirmSuccess: 'Booking confirmed!'
      },
      services: {
        add: 'Add Service',
        edit: 'Edit',
        name: 'Service Name',
        description: 'Description',
        price: 'Price',
        duration: 'Duration (min)',
        icon: 'Icon',
        save: 'Save',
        cancel: 'Cancel',
        categoryImages: 'Category Images',
        saveImages: 'Save images',
        placeholders: {
          name: 'Ex: Women Haircut',
          description: 'Detailed description...',
          price: '0.00'
        },
        icons: {
          scissors: 'Scissors',
          droplet: 'Coloring',
          palette: 'Balayage',
          zap: 'Straightening',
          wind: 'Styling',
          sparkles: 'Treatment',
          pack: 'Pack',
          heart: 'Massage & Relaxation',
          flower: 'Massage & Care',
          plus: 'Extras'
        }
      },
      gallery: {
        add: 'Add Media',
        dropzone: 'Drag photos or videos here',
        formats: 'JPG, PNG, MP4, WEBM (Max 50MB)',
        deleteConfirm: 'Delete this media?',
        success: 'Media added successfully'
      },
      account: {
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        errorMatch: 'Passwords do not match',
        success: 'Account updated successfully',
        save: 'Save'
      },
      stats: {
        title: 'Statistics',
        subtitle: 'Performance analysis',
        totalRevenue: 'Revenue',
        totalBookings: 'Bookings',
        activeServices: 'Active Services',
        detailsTitle: 'Activity Details'
      }
    }
  },
  pt: {
    nav: {
      home: 'Início',
      services: 'Serviços',
      rates: 'Tarifas',
      reviews: 'Avaliações',
      booking: 'Reserva',
      about: 'Sobre',
      gallery: 'Galeria',
      contact: 'Contato',
      admin: 'Administração',
      logout: 'Sair',
      login: 'Entrar',
      profile: 'Meu Perfil',
      myAccount: 'Minha Conta',
      roleAdmin: 'Administrador',
      roleUser: 'Cliente',
      myBookings: 'Minhas Reservas'
    },
    userBookings: {
      title: 'Os Meus Agendamentos',
      subtitle: 'Veja o histórico e o acompanhamento dos seus serviços.',
      countLabel: 'Serviços',
      searchPlaceholder: 'Pesquisar serviço ou morada...',
      filterAll: 'Todos',
      filterConfirmed: 'Confirmados',
      filterPending: 'Pendente',
      guaranteeLabel: 'Garantia',
      emptyTitle: 'Nenhum agendamento encontrado',
      emptySearch: 'Tente alterar os filtros de pesquisa',
      emptyNoBookings: 'Ainda não efetuou qualquer reserva.',
      loading: 'A carregar os seus agendamentos...',
      error: 'Erro durante a recuperação',
      retry: 'Tentar novamente',
      status: {
        confirmed: 'Confirmado',
        pending: 'Pendente',
        cancelled: 'Cancelado',
        'no-show': 'Não compareceu'
      }
    },
    hero: {
      badge: 'EXCELÊNCIA À SUA PORTA',
      title: 'Haircare & Relaxation',
      subtitle: 'Herança & Paixão',
      cta: 'Saiba mais'
    },
    rates: {
      badge: 'Serviços Premium',
      title: 'Nossos Preços e Serviços',
      subtitle: 'Selecione une categoria para ver os detalhes',
      bookBtn: 'Reservar',
      viewDetails: 'VER SERVIÇOS',
      prestigeLabel: 'Serviços de prestígio',
      priceLabel: 'Preço',
      noService: 'Nenhum service disponível.',
      categories: {
        haircut: 'Corte',
        coloring: 'Coloração',
        balayage: 'Balayage',
        lissage: 'Escova Progressiva',
        styling: 'Penteado',
        treatment: 'Tratamento',
        pack: 'Pacotes',
        massageDetente: 'Massagem & Relaxamento',
        massageSoins: 'Massagem e Cuidados',
        extras: 'Extras / Adicionais'
      }
    },
    reviews: {
        badge: 'Depoimentos Autênticos',
        title: 'Avaliações de Clientes',
        subtitle: 'Veja o que nossos clientes dizem sobre nós',
        addTitle: 'Deixar uma avaliação',
        ratingLabel: 'Sua nota',
        commentLabel: 'Seu comentário',
        placeholder: 'Conte-nos sobre sua experiência...',
        submit: 'Publicar avaliação',
        loginRequired: 'Faça login para deixar une avaliação.',
        empty: 'Seja o primeiro a avaliar!'
    },
    booking: {
      title: 'Reservar a sua prestação',
      steps: {
        services: '01. Prestações',
        date: '02. Data',
        time: '03. Hora',
        personal: '04. Detalhes',
        summary: '05. Resumo'
      },
      selectService: 'Selecionar um serviço...',
      addService: 'Adicionar um serviço',
      selectDateFirst: 'Selecione primeiro uma data',
      name: 'Nome completo *',
      email: 'Email *',
      phone: 'Telefone',
      address: 'Endereço completo *',
      validation: {
        service: 'Serviço',
        date: 'Data',
        time: 'Hora',
        name: 'Nome',
        email: 'Email',
        address: 'Endereço'
      },
      summary: {
        estimated: 'Valor Estimado',
        onPlace: 'A pagar no local'
      },
      deposit: {
        title: 'Condições de Garantia',
        bankGuarantee: 'Garantia Bancária',
        policy1: 'Garantia de 20€ via 3D Secure (não debitada).',
        policy2: 'O agendamento deve ser confirmado pelo cabeleireiro.',
        accept: 'Aceito as condições gerais',
        disclaimer: 'O seu cartão será verificado pelo 3D Secure, mas nenhum débito ocorrerá hoje.',
        completeFormError: 'Por favor, preencha todos os campos e aceite as condições para continuar.'
      },
      placeholders: {
        zip: 'Código postal',
        notes: 'Informações adicionais (código da porta, andar...)'
      },
      success: {
        title: 'Pedido Enviado!',
        body: 'Sua garantia foi validada. Seu agendamento está agora <strong>aguardando confirmação</strong>. Receberá um e-mail de confirmação em breve.',
        returnHome: 'Voltar ao início'
      },
      submit: 'Reservar e Garantir'
    },
    about: {
      badge: 'NOSSA HISTÓRIA',
      title: 'Sobre mim',
      subtitle: 'Paixão, Excelência & Tradição',
      storyTitle: 'QUEM SOMOS?',
      text: "Olá, o meu nome est Marie.\n\nSou cabeleireira francesa, com 14 anos de experiência e trabalho ao domicílio em Lisboa desde Janeiro de 2024.",
      ctaAbout: 'Saiba mais',
      features: {
        excellence: {
          title: 'Excelência',
          desc: 'Um know-how de exceção transmitido com paixão para resultados impecáveis.'
        },
        passion: {
          title: 'Paixão',
          desc: 'Cada corte é realizado com amor para realçar a sua beleza.'
        },
        proximity: {
          title: 'Proximidade',
          desc: 'Um serviço personalizado ao domicílio para o seu conforto.'
        }
      }
    },
    gallery: {
      title: 'Nossa Galeria',
      subtitle: 'Descubra nossos trabalhos em fotos e vídeos',
      empty: 'Nenhum conteúdo na galeria ainda.'
    },
    contact: {
      badge: 'Fique em Contato',
      title: 'Entre em contato',
      subtitle: 'Estamos à disposição para responder todas as suas perguntas',
      phone: 'Telefone',
      email: 'Email',
      emailSend: 'Clique para enviar uma mensagem',
      hours: 'Horário',
      hoursText: 'Seg-Dom: 10h-20h',
      socialTitle: 'Siga-nos',
      socialText: 'Junte-se à nossa comunidade nas redes sociais'
    },
    auth: {
      loginTitle: 'Entrar',
      signupTitle: 'Criar conta',
      welcome: 'Bem-vindo à Haircare & Relaxation',
      name: 'Sobrenome',
      firstname: 'Nome',
      email: 'Endereço de e-mail',
      password: 'Senha',
      phone: 'Telefone',
      address: 'Endereço',
      language: 'Idioma preferido',
      submitLogin: 'Entrar',
      submitSignup: 'Inscrever-se',
      switchLogin: 'Já tem uma conta? Entrar',
      switchSignup: "Não tem conta? Inscrever-se",
      backToHome: 'Voltar ao início',
      passwordRequirements: 'A senha deve ter pelo menos 12 caracteres, uma letra, um número e um caractere especial.',
      forgotPassword: 'Esqueci a senha',
      sendResetLink: 'Enviar Link',
      resetTitle: 'Redefinir Senha',
      newPassword: 'Nova Senha',
      confirmPassword: 'Confirmar Senha',
      resetSuccess: 'Senha redefinida! Você pode entrar.',
      emailSent: 'Se esta conta existir, un link foi enviado.',
      backToLogin: 'Voltar ao login'
    },
    profile: {
      title: 'Meu Perfil',
	  badge: 'Meu Espaço Pessoal',
      subtitle: 'Gerencie suas informações pessoais',
      personalInfo: 'Informações Pessoais',
      success: 'Perfil atualizado com sucesso',
      error: 'Erro ao atualizar perfil',
      security: 'Segurança',
      oldPassword: 'Senha Antiga',
      passSuccess: 'Senha atualizada!',
      emailNotice: 'O e-mail não pode ser alterado.',
      updatePassBtn: 'Atualizar palavra-passe'
    },
    admin: {
      title: 'Painel de Administração',
      tabs: {
        bookings: 'Reservas',
        services: 'Services',
        gallery: 'Galeria',
        about: 'Sobre',
        account: 'Minha Conta',
        translations: 'Traduções',
        stats: 'Estatísticas'
      },
      common: {
        today: "Hoje",
        day: 'Dia',
        week: 'Semana',
        month: 'Mês',
        list: 'Lista',
        newBooking: 'Novo Agendamento',
        loading: 'Carregando...',
        save: 'Salvar',
        cancel: 'Cancelar',
        delete: 'Excluir',
        abandon: 'Descartar',
        edit: 'Editar',
        actions: 'Ações'
      },
      bookings: {
        modalTitleAdd: 'Agendar serviço',
        modalTitleEdit: 'Editar agendamento',
        customer: 'Cliente',
        service: 'Serviço',
        date: 'Date',
        time: 'Hora',
        status: 'Status',
        address: 'Endereço',
        notes: 'Notas',
        confirmed: 'Confirmado',
        pending: 'Pendente',
        confirm: 'Confirmar',
        noBookings: 'Nenhuma reserva encontrada.',
        confirmSuccess: 'Reserva confirmada!'
      },
      services: {
        add: 'Adicionar Serviço',
        edit: 'Editar',
        name: 'Nome do Serviço',
        description: 'Descrição',
        price: 'Preço',
        duration: 'Duração (min)',
        icon: 'Ícone',
        save: 'Salvar',
        cancel: 'Cancelar',
        categoryImages: 'Imagens de Categoria',
        saveImages: 'Salvar imagens',
        placeholders: {
          name: 'Ex: Corte Feminino',
          description: 'Descrição detalhada...',
          price: '0.00'
        },
        icons: {
          scissors: 'Tesoura',
          droplet: 'Coloração',
          palette: 'Balayage',
          zap: 'Escova',
          wind: 'Penteado',
          sparkles: 'Tratamento',
          pack: 'Pacote',
          heart: 'Massagem & Relaxamento',
          flower: 'Massagem e Cuidados',
          plus: 'Extras'
        }
      },
      gallery: {
        add: 'Adicionar Mídia',
        dropzone: 'Arraste fotos ou vídeos aqui',
        formats: 'JPG, PNG, MP4, WEBM (Máx 50MB)',
        deleteConfirm: 'Excluir esta mídia?',
        success: 'Mídia adicionada com sucesso'
      },
      account: {
        newPassword: 'Nova Senha',
        confirmPassword: 'Confirmar Senha',
        errorMatch: 'As palavras-passe não coincidem',
        success: 'Conta atualizada com sucesso',
        save: 'Salvar'
      },
      stats: {
        title: 'Estatísticas',
        subtitle: 'Análise de desempenho',
        totalRevenue: 'Receita',
        totalBookings: 'Reservas',
        activeServices: 'Serviços Ativos',
        detailsTitle: 'Detalhes da atividade'
      }
    }
  }
};
